<div class="standardize-contract-list-dialog">
    <div class="dialog-title-row">
      <h2 mat-dialog-title>{{ 'labor_contract_standardize.dialog.title' | translate }}</h2>
      <button mat-icon-button type="button" class="close-button" [attr.aria-label]="'button.close' | translate" (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-divider></mat-divider>

    <div class="dialog-summary"
    *ngIf="listContractValid.length === contracts.length"
    [innerHTML]="'labor_contract_standardize.dialog.summary' | translate: { count: contracts.length }"
    >
    </div>
    <ng-container *ngIf="listContractValid.length < contracts.length && listContractValid.length > 0">
      <div class="dialog-summary-warning"
      [innerHTML]="'labor_contract_standardize.dialog.note_warning' | translate: { x: (contracts.length - listContractValid.length) + '/' + contracts.length }"
      >
      </div>
      <div class="dialog-summary"
      [innerHTML]="'labor_contract_standardize.dialog.proccess_contract' | translate: { x: listContractValid.length }"
      >
      </div>
    </ng-container>
   
    

    <mat-dialog-content>
      <section class="contract-list-panel">
        <div class="contract-list-header">
          <h3>
            {{ 'labor_contract_standardize.dialog.list_title' | translate }}
            <strong>({{ listContractValid.length }})</strong>
          </h3>
          <span>{{ 'labor_contract_standardize.dialog.limit_info' | translate: { max: maxContracts } }}</span>
        </div>

        <div class="contract-table-wrapper">
          <mat-table [dataSource]="listContractValid" class="contract-table">
            <ng-container matColumnDef="stt">
              <mat-header-cell *matHeaderCellDef class="number-column">{{ 'labor_contract_standardize.dialog.table_headers.stt' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let contract; let index = index" class="number-column">
                {{ index + 1 }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="codeName">
              <mat-header-cell *matHeaderCellDef>{{ 'labor_contract_standardize.dialog.table_headers.code_name' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let contract" [matTooltip]="contract.codeName">
                <span class="ellipsis">{{ contract.codeName || '-' }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="contractType">
              <mat-header-cell *matHeaderCellDef>{{ 'labor_contract_standardize.dialog.table_headers.contract_type' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let contract" [matTooltip]="contract.contractType">
                <span class="ellipsis">{{ contract.contractType || '-' }}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="parties">
              <mat-header-cell *matHeaderCellDef>{{ 'labor_contract_standardize.dialog.table_headers.parties' | translate }}</mat-header-cell>
              <mat-cell *matCellDef="let contract" [matTooltip]="contract.parties">
                <span class="ellipsis">{{ contract.parties || '-' }}</span>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
        </div>
      </section>
    </mat-dialog-content>

    <mat-divider></mat-divider>

    <mat-dialog-actions align="center">
      <button mat-stroked-button color="primary" type="button" (click)="onCancel()">
        <mat-icon>cancel</mat-icon>
        {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" type="button" cdkFocusInitial (click)="onConfirm()">
        <mat-icon>check_circle_outline</mat-icon>
        {{ 'button.confirm' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
